var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMan4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 457 457",
    style: {
      enableBackground: "new 0 0 457 457"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A67C52"
    },
    cx: 147.928,
    cy: 184,
    r: 27.89
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A67C52"
    },
    cx: 309.063,
    cy: 184,
    r: 27.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M147.928,217.89c-18.687,0-33.89-15.203-33.89-33.89s15.203-33.89,33.89-33.89 s33.89,15.203,33.89,33.89S166.615,217.89,147.928,217.89z M147.928,162.11c-12.07,0-21.89,9.82-21.89,21.89 s9.82,21.89,21.89,21.89s21.89-9.82,21.89-21.89S159.998,162.11,147.928,162.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M309.063,217.89c-18.687,0-33.89-15.203-33.89-33.89s15.203-33.89,33.89-33.89 s33.89,15.203,33.89,33.89S327.75,217.89,309.063,217.89z M309.063,162.11c-12.07,0-21.89,9.82-21.89,21.89 s9.82,21.89,21.89,21.89s21.89-9.82,21.89-21.89S321.133,162.11,309.063,162.11z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M277.855,279.97c0.19,0.05,0.39,0.09,0.58,0.14c10.46,2.53,20.19,6.93,28.83,12.81 c23.39,15.92,38.75,42.77,38.75,73.19V451h-47.04h-140.96h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 c8.64-5.88,18.37-10.28,28.83-12.81c0.19-0.05,0.39-0.09,0.58-0.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A67C52"
    },
    d: "M158.015,327v124h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 C155.025,303.12,158.015,314.71,158.015,327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A67C52"
    },
    d: "M346.015,366.11V451h-47.04V327c0-12.29,2.99-23.88,8.29-34.08 C330.655,308.84,346.015,335.69,346.015,366.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A67C52"
    },
    d: "M278.435,280.11v13.808c0,27.58-22.36,49.94-49.94,49.94s-49.94-22.36-49.94-49.94V280.11 c0.19-0.05,0.39-0.09,0.58-0.14c14.1,9.49,31.08,15.03,49.36,15.03s35.26-5.54,49.36-15.03 C278.045,280.02,278.245,280.06,278.435,280.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M276.875,280.62c-6.74,12.83-16.55,23.81-28.44,31.95 c-0.19,0.14-0.39,0.27-0.58,0.4c-14.1,9.49-31.08,15.03-49.36,15.03c-6.5,0-6.267-7.273-12.367-8.613 c-0.66-3.23-7.573-7.467-7.573-10.887v-28.39c0.19-0.05,0.39-0.09,0.58-0.14c14.1,9.49,31.08,15.03,49.36,15.03 C246.355,295,262.975,289.71,276.875,280.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A67C52"
    },
    d: "M277.855,279.97c-14.1,9.49-31.08,15.03-49.36,15.03s-35.26-5.54-49.36-15.03 c-0.19-0.13-0.39-0.26-0.58-0.4c-23.28-15.94-38.56-42.72-38.56-73.07V184v-51.5c0-48.877,39.623-88.5,88.5-88.5l0,0 c48.877,0,88.5,39.623,88.5,88.5V184v22.5c0,30.35-15.28,57.13-38.56,73.07C278.245,279.71,278.045,279.84,277.855,279.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M228.495,301c-18.88,0-37.107-5.551-52.71-16.052l-0.182-0.124c-0.169-0.114-0.339-0.23-0.506-0.35 c-25.737-17.657-41.102-46.8-41.102-77.974v-74c0-52.107,42.393-94.5,94.5-94.5s94.5,42.393,94.5,94.5v74 c0,31.176-15.362,60.318-41.102,77.974c-0.167,0.12-0.337,0.236-0.506,0.351l-0.136,0.092c-0.015,0.01-0.03,0.021-0.045,0.031 C265.603,295.449,247.375,301,228.495,301z M228.495,50c-45.491,0-82.5,37.009-82.5,82.5v74c0,27.241,13.439,52.706,35.95,68.12 c0.055,0.038,0.111,0.077,0.165,0.117l0.421,0.287c13.57,9.133,29.48,13.977,45.964,13.977s32.395-4.844,46.01-14.007l0.167-0.114 c0.069-0.047,0.141-0.093,0.208-0.143c0.054-0.04,0.109-0.079,0.165-0.117c22.51-15.414,35.95-40.879,35.95-68.12v-74 C310.995,87.009,273.986,50,228.495,50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M228.495,349.858c-30.845,0-55.94-25.095-55.94-55.94V279.57h12v14.348 c0,24.229,19.711,43.94,43.94,43.94s43.94-19.711,43.94-43.94V279.57h12v14.348C284.435,324.764,259.34,349.858,228.495,349.858z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M196.885,204.437c-1.58,0-3.13-0.64-4.24-1.75c-1.12-1.12-1.76-2.67-1.76-4.25s0.64-3.12,1.76-4.24 c1.39-1.39,3.46-2.03,5.41-1.64c0.39,0.08,0.76,0.19,1.13,0.34c0.36,0.15,0.71,0.34,1.03,0.55c0.33,0.22,0.64,0.47,0.91,0.75 c0.28,0.28,0.53,0.58,0.75,0.91s0.4,0.68,0.55,1.04c0.15,0.36,0.27,0.74,0.34,1.12c0.08,0.39,0.12,0.78,0.12,1.17 s-0.04,0.79-0.12,1.18c-0.07,0.38-0.19,0.76-0.34,1.12s-0.33,0.71-0.55,1.03c-0.22,0.33-0.47,0.64-0.75,0.92 C200.015,203.797,198.465,204.437,196.885,204.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M264.885,204.437c-0.39,0-0.79-0.04-1.17-0.11c-0.38-0.08-0.76-0.2-1.12-0.35 c-0.37-0.15-0.71-0.33-1.04-0.55c-0.33-0.22-0.64-0.47-0.91-0.74c-0.28-0.28-0.53-0.59-0.75-0.92c-0.22-0.32-0.4-0.67-0.55-1.03 s-0.27-0.74-0.34-1.12c-0.08-0.39-0.12-0.79-0.12-1.18s0.04-0.78,0.12-1.17c0.07-0.38,0.19-0.76,0.34-1.12s0.33-0.71,0.55-1.04 c0.22-0.33,0.47-0.63,0.75-0.91c0.27-0.28,0.58-0.53,0.91-0.75c0.33-0.21,0.67-0.4,1.04-0.55c0.36-0.15,0.74-0.26,1.12-0.34 c1.95-0.39,4.02,0.25,5.41,1.64c0.28,0.28,0.53,0.58,0.75,0.91s0.4,0.68,0.55,1.04s0.27,0.74,0.34,1.12 c0.08,0.39,0.12,0.78,0.12,1.17s-0.04,0.79-0.12,1.18c-0.07,0.38-0.19,0.76-0.34,1.12s-0.33,0.71-0.55,1.03 c-0.22,0.33-0.47,0.64-0.75,0.92C268.015,203.797,266.465,204.437,264.885,204.437z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M221.552,218c-3.313,0-6-2.687-6-6v-16.856c0-3.204-2.606-5.81-5.81-5.81h-28.58 c-3.313,0-6-2.687-6-6s2.687-6,6-6h28.58c9.82,0,17.81,7.99,17.81,17.81V212C227.552,215.313,224.865,218,221.552,218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M275.829,189.333h-24c-3.313,0-6-2.687-6-6s2.687-6,6-6h24c3.313,0,6,2.687,6,6 S279.142,189.333,275.829,189.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M240.495,253.333h-24c-3.313,0-6-2.687-6-6s2.687-6,6-6h24c3.313,0,6,2.687,6,6 S243.809,253.333,240.495,253.333z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M346.015,366.11V386h-45.7h-1.34v-59c0-12.29,2.99-23.88,8.29-34.08 C330.655,308.84,346.015,335.69,346.015,366.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M158.015,327v59h-47.03v-19.89c0-30.42,15.35-57.27,38.74-73.19 C155.025,303.12,158.015,314.71,158.015,327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M304.975,451h-12V327c0-12.816,3.1-25.558,8.966-36.846l10.648,5.533 c-5.052,9.724-7.614,20.259-7.614,31.313V451z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.315,
    y: 380,
    style: {
      fill: "#333333"
    },
    width: 47.03,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M326.015,437c-3.313,0-6-2.687-6-6v-27c0-3.313,2.687-6,6-6s6,2.687,6,6v27 C332.015,434.313,329.329,437,326.015,437z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M154.665,304.92c-15.21,15.89-24.56,37.45-24.56,61.19V449 h-19.12v-82.89c0-30.42,15.35-57.27,38.74-73.19C151.705,296.74,153.365,300.75,154.665,304.92z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M346.015,457h-235.03c-3.314,0-6-2.686-6-6v-84.89c0-31.306,15.463-60.521,41.364-78.15 c9.416-6.408,19.762-11.007,30.752-13.671c0.131-0.033,0.264-0.065,0.397-0.096l0.122-0.028l3.037,11.609 c-0.153,0.04-0.309,0.077-0.465,0.113l-0.122,0.028c-0.017,0.004-0.087,0.022-0.104,0.026c-9.597,2.321-18.636,6.338-26.865,11.938 c-22.614,15.392-36.115,40.898-36.115,68.229V445h223.03v-78.89c0-27.327-13.505-52.833-36.126-68.23 c-8.229-5.6-17.268-9.617-26.865-11.938c-0.037-0.009-0.074-0.019-0.111-0.028l-0.116-0.027c-0.156-0.036-0.312-0.073-0.464-0.113 l3.038-11.609l0.122,0.028c0.133,0.031,0.266,0.062,0.396,0.095c10.99,2.664,21.336,7.264,30.751,13.671 c25.908,17.633,41.375,46.848,41.375,78.15V451C352.015,454.314,349.329,457,346.015,457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M164.015,451h-12V327c0-11.055-2.562-21.59-7.614-31.313l10.648-5.533 c5.865,11.288,8.966,24.029,8.966,36.847V451z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.985,
    y: 380,
    style: {
      fill: "#333333"
    },
    width: 47.03,
    height: 12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M360,457H97.23c-3.313,0-6-2.687-6-6s2.687-6,6-6H360c3.313,0,6,2.687,6,6S363.313,457,360,457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M392,457h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S395.313,457,392,457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M76,457H65c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S79.313,457,76,457z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M210.135,279.97c10.02,6.74,21.5,11.49,33.86,13.68 c-5.03,0.89-10.21,1.35-15.5,1.35c-18.28,0-35.26-5.54-49.36-15.03c-0.19-0.13-0.39-0.26-0.58-0.4 c-23.28-15.94-38.56-42.72-38.56-73.07V184c0-139,54.89-137.301,54.89-134.411l-10.384,15.807 c-15.364,23.387-15.305,53.174-0.958,76.231c2.423,3.895,10.151,17.294,10.019,20.366c-0.483,11.29-9.201,21.36-21.338,21.975 c-0.407,0.021-0.817,0.031-1.229,0.031v22.5c0,30.35,15.28,57.13,38.56,73.07C209.745,279.71,209.945,279.84,210.135,279.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301,212c-3.313,0-6-2.687-6-6v-45c0-3.313,2.687-6,6-6s6,2.687,6,6v45 C307,209.313,304.313,212,301,212z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M359.23,126.74c0,35.15-16.27,52.5-42.23,61.03v-31.51c0-6.11-3.58-11.73-9.35-14.72 c-6.14-3.2-11.81-7.07-16.88-11.51c-5.71-5.01-14.33-6.06-21.21-2.53c-12.17,6.23-26.16,9.78-41.06,9.78 c-14.89,0-28.9-3.55-41.07-9.78c-6.88-3.53-15.5-2.48-21.21,2.53c-5.07,4.44-10.73,8.31-16.86,11.5 c-5.77,2.99-9.35,8.62-9.35,14.73v31.52c-12.99-4.27-23.55-10.74-30.87-20.54c-7.31-9.8-11.38-22.92-11.38-40.5 C97.76,60.05,156.29,6,228.49,6C300.7,6,359.23,60.05,359.23,126.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#333333"
    },
    points: "317,193.77 316.99,181.77 317,181.77  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M317.001,211.77c-3.313,0-6-2.685-6.001-5.999l-0.01-36c0-1.591,0.631-3.118,1.757-4.244 c1.125-1.125,2.651-1.758,4.243-1.758c3.313,0,6.01,2.687,6.01,6v36C323,209.083,320.314,211.77,317.001,211.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M140.01,193.78c-0.628,0-1.261-0.099-1.873-0.3c-15.06-4.95-26.117-12.359-33.804-22.649 c-8.461-11.344-12.573-25.765-12.573-44.091C91.76,56.855,153.097,0,228.49,0c75.399,0,136.74,56.855,136.74,126.74 c0,34.653-15.164,56.48-46.357,66.73c-1.829,0.602-3.833,0.288-5.392-0.84S311,189.694,311,187.77v-31.51 c0-3.841-2.341-7.44-6.11-9.393c-6.561-3.419-12.637-7.563-18.072-12.323c-3.879-3.403-9.847-4.103-14.519-1.706 c-13.346,6.832-28.49,10.442-43.799,10.442c-15.315,0-30.463-3.61-43.804-10.439c-4.677-2.399-10.646-1.7-14.519,1.699 c-5.454,4.776-11.524,8.917-18.047,12.313c-3.779,1.958-6.12,5.561-6.12,9.408v31.52c0,1.924-0.923,3.732-2.481,4.86 C142.492,193.391,141.258,193.78,140.01,193.78z M228.49,12c-68.776,0-124.73,51.472-124.73,114.74 c0,15.646,3.333,27.721,10.189,36.913c4.797,6.422,11.402,11.5,20.061,15.394V156.26c0-8.348,4.824-16.034,12.59-20.057 c5.664-2.948,10.938-6.545,15.667-10.687c7.599-6.668,18.814-8.018,27.902-3.355c11.652,5.965,24.908,9.119,38.331,9.119 c13.417,0,26.669-3.154,38.326-9.121c9.084-4.661,20.298-3.311,27.901,3.361c4.712,4.126,9.995,7.728,15.696,10.699 c7.753,4.018,12.577,11.7,12.577,20.041v22.776c20.834-9.374,30.23-25.819,30.23-52.296C353.23,63.472,297.272,12,228.49,12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M334.94,160.355c-1.079,0-2.171-0.291-3.155-0.901c-2.816-1.746-3.685-5.444-1.938-8.261 c1.13-1.823,2.09-3.884,2.854-6.127c1.068-3.137,4.479-4.813,7.614-3.745c3.137,1.069,4.813,4.478,3.745,7.614 c-1.057,3.101-2.407,5.988-4.014,8.581C338.911,159.348,336.948,160.355,334.94,160.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.23,132.74c-3.313,0-6-2.687-6-6c0-42.666-31.569-80.85-76.77-92.858 c-3.203-0.851-5.109-4.137-4.258-7.339c0.851-3.203,4.139-5.11,7.339-4.258c24.128,6.41,45.883,20.062,61.256,38.44 c15.984,19.108,24.433,41.937,24.433,66.016C347.23,130.054,344.543,132.74,341.23,132.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M240.007,30.532c-0.186,0-0.373-0.009-0.561-0.026C235.829,30.17,232.143,30,228.49,30 c-3.313,0-6-2.687-6-6s2.687-6,6-6c4.021,0,8.08,0.188,12.064,0.557c3.299,0.306,5.726,3.229,5.42,6.528 C245.686,28.196,243.071,30.532,240.007,30.532z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan4);
export default __webpack_public_path__ + "static/media/man4.7c4b2e417a3a5128a36555638691db8f.svg";
export { ForwardRef as ReactComponent };